import { cn } from 'noddi-ui-common';
import { ReactNode } from 'react';

export const TextOrNode = ({ value, className }: { value: ReactNode | undefined | null; className?: string }) =>
  typeof value === 'string' || typeof value === 'number' ? (
    <span className={cn('py-2 pr-2', className)}>{value}</span>
  ) : (
    value
  );
